import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { confirmCode } from '../../../redux/auth/actions';

import Input from '../../common/FormFields/Input';
import Button from '../../common/FormFields/Button';
import Loader from '../../common/Loader';

const TwoFactorForm = (props) => {
  const [code, setCode] = useState('');
  const { t } = useTranslation();
  const formClassName = 'form auth-form two-factor';
  const { confirmCode, isTwoFactorError, loginLoading } = props;

  const handleClick = (e) => {
    e.preventDefault();
    confirmCode(code)
  }

  return (
    <>
      {loginLoading && <Loader className="is-fixed" />}
      <form action="submit" className={formClassName}>
        <h1 className="auth-title-2">{t('auth.enterCodeToProceed')}</h1>
        <div className="auth-body">
          <Input
            type="text"
            placeholder={t('auth.enterYourCode')}
            label={t('auth.code')}
            errorMessage={isTwoFactorError ? 'Invalid Code' : ''}
            onChangeValue={setCode}
            autoFocus={true}
          />
        </div>
        <div className="auth-footer">
          <Button
            btnClassName="btn-primary"
            text={t('auth.confirm')}
            id="sign-in-button"
            onClick={handleClick}
          />
        </div>
        <span id="recaptcha-sign-in-anchor"></span>
      </form>
    </>
  );
};
const mapStateToProps = (state) => ({
  isTwoFactorError: state.authReducer.isTwoFactorError,
  loginLoading: state.authReducer.finalizeLoginLoading,
});
const mapDispatchToProps = {
  confirmCode
}
export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorForm);
